import { ref, computed } from 'vue'
import { useLocaleStore } from '@/store/modules/locale'
import en from '@arco-design/web-vue/es/locale/lang/en-us'
import zh from '@arco-design/web-vue/es/locale/lang/zh-cn'
import tw from '@arco-design/web-vue/es/locale/lang/zh-tw'
import { useAppStore } from '@/store/modules/app'
import utils from '@/utils/cookie'
import { Base64 } from 'js-base64'

const localeStore = useLocaleStore()
const currentLang = computed(() => {
  const _lang = localeStore.getCurrentLocale?.elLocale?.name || localeStore.getCurrentLocale?.lang
  const _obj = {
    'zh-cn': 'zh',
    'zh-tw': 'zt',
    en: 'en'
  }
  return _obj[_lang] || 'en'
})

const getOrgId = () => {
  // 区分单个org与多org
  try {
    const orgId: any = JSON.parse(localStorage.getItem('currentOrgId'))
    if (orgId) {
      return Number(orgId)
    } else {
      const curOrg = JSON.parse(localStorage.getItem('orgNum'))?.data?.currentOrgId
      return curOrg + '' ? curOrg : 1
    }
  } catch (err) {
    return 1
  }
}

const aConfigProviderLang: any = computed(() => {
  const _lang = localeStore.getCurrentLocale.elLocale?.name
  const _obj = {
    'zh-cn': zh,
    'zh-tw': tw,
    en: en
  }
  const target = _obj[_lang] || en
  return target
})

const commonAreaHasDefault = computed(() => {
  let target = true
  // 获取全局配置
  try {
    const local = JSON.parse(localStorage.getItem('ecowatch_wholeConfig'))
    if (local && local?.area_has_default !== undefined) {
      target = local?.area_has_default
    }
  } catch (err) {}

  return target
})

const commonAreaCascade = computed(() => {
  let target = false
  // 获取全局配置
  try {
    const local = JSON.parse(localStorage.getItem('ecowatch_wholeConfig'))
    if (local && local?.area_cascade !== undefined) {
      target = local?.area_cascade
    }
  } catch (err) { }
  
  return target
})

const appStore = useAppStore()
const isDark = computed(() => {
  return appStore.getTheme.topHeaderBgColor ? appStore.getTheme.topHeaderBgColor : '#fff'
})

const commonUserInfo: any = computed(() => {
  // 从token中获取用户名
  const tokenAll = utils.getCookie('EIToken') || sessionStorage?.getItem('EIToken')
  const token = tokenAll?.split('.')

  const str = token?.length ? token[1] : ''
  const user = str ? JSON.parse(Base64.decode(str)) : {}
  return user
})

export const ecoCommonInfo = () => {
  const ecoLang = ref<any>('')
  const ecoOrgId = ref('')
  const arcoLang: any = ref('')
  const areaHasDefault = ref(true)
  const areaCascade = ref<any>(true)

  ecoLang.value = currentLang.value
  ecoOrgId.value = getOrgId()
  arcoLang.value = aConfigProviderLang.value
  areaHasDefault.value = commonAreaHasDefault.value
  areaCascade.value = commonAreaCascade.value

  return {
    ecoLang,
    ecoOrgId,
    arcoLang,
    areaHasDefault,
    areaCascade,
    isDark,
    commonUserInfo
  }
}
